import React, {useEffect, useState} from "react";
import BlogImagePopper from "./BlogImageLarge";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import image8 from "../../../../assets/images/blog16-8.png";
import image2 from "../../../../assets/images/blog16-2.png";
import image23 from "../../../../assets/images/blog16-23.png";
import image9 from "../../../../assets/images/blog16-9.png";
import image16 from "../../../../assets/images/blog16-16.png";
import image17 from "../../../../assets/images/blog16-17.png";
import image12 from "../../../../assets/images/blog16-12.png";
import image10 from "../../../../assets/images/blog16-10.png";
import image11 from "../../../../assets/images/blog16-11.png";
import image30 from "../../../../assets/images/blog16-30.png";
import image20 from "../../../../assets/images/blog16-20.png";
import image21 from "../../../../assets/images/blog16-21.png";
import image28 from "../../../../assets/images/blog16-28.png";
import image24 from "../../../../assets/images/blog16-24.png";

const Blog16 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook: April 28, 2025</h2>
      </div>
      <div className="blogContentnew">
        <p
          style={{
            textAlign: "justify",
            fontFamily: "var(--header-font-family)",
            fontSize: "24px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "30px",
            color: "#010310",
          }}
        >
          "Leaking Glass, MAG7 Power & Tariff Jitters"
        </p>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Key Market Themes: A Geopolitical Tightrope and MAG7 Mania</p>
              <p>Trump’s central bank poking, China’s trade flip-flops, and Russia’s staged posturing made for a loud macro week. Yet through it all, the US markets cling to safe-haven status.</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US-China trade shows deceleration </span>
                  </p>
                </li>
                <div className="relatedImg">
                  <img
                    src={image8}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image8)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Dollar trust erosion fears grow</span>
                  </p>
                </li>
                <div className="relatedImg">
                  <img
                    src={image2}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image2)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </ul>
              <div className="contentDiv">
                <p>De-dollarisation risks loom, but liquidity remains positive in the short run. Meanwhile, MAG7 earnings juggernauts look ready to unleash another AI-fueled rally.</p>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="subHeader">
          <p className="highlightedBoldText">Technical & Sentiment Analysis: Is This Rally for Real?</p>

          <div className="subHeader">
            <div className="contentDivWrapper ">
              <div className="contentDiv listOfRecap">
                <p className="">The SPX has rebounded fiercely from the post-Liberation Day crash, but critical technical crossroads are here:</p>
                <ul className="pointersSection">
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">SPX Decision Point:</span> Hovering at the 50% Fib retracement
                    </p>
                  </li>
                  <div className="relatedImg">
                    <img
                      src={image23}
                      alt=""
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image23)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Breadth shallow: </span>Despite strong price action, underlying breadth remains suspect
                    </p>
                  </li>
                  <div className="relatedImg">
                    <img
                      src={image9}
                      alt=""
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image9)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>

                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">VIX </span>is cooling but not yet comfortably low
                    </p>
                  </li>
                  <div className="relatedImg">
                    <img
                      src={image16}
                      alt=""
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image16)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">VVIX </span>calming signals volatility premium fading
                    </p>
                  </li>
                  <div className="relatedImg">
                    <img
                      src={image17}
                      alt=""
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image17)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Retail sour, insiders buying:</span>
                    </p>
                  </li>
                  <div className="relatedImg">
                    <img
                      src={image12}
                      alt=""
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image12)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                  <p>Historical echoes from 1998 remain strong but suggest a re-test of lows before the breakout:</p>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Ken Fisher's 1998 analogy</span>
                    </p>
                  </li>
                  <div className="relatedImg">
                    <img
                      src={image10}
                      alt=""
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image10)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Jurrien Timmer's breakdown retest thesis </span>
                    </p>
                  </li>
                  <div className="relatedImg">
                    <img
                      src={image11}
                      alt=""
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image11)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </ul>

                <span className="highlightedText_header">Pain Trade: </span>
                <p className="highlightedText_lighter">Upwards as even the bulls see a pullback.</p>

                <span className="highlightedText_header">Short-Term Risk: </span>
                <p className="highlightedText_lighter">Choppy pullback before real upside.</p>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap ">
              <div className="listImgWrapper">
                <p className="highlightedBoldText">Last Week’s Recap: Wall Street Roars as Tariffs Bite Main Street</p>
                <p className="highlightedText_header">Big beats from AI-powered companies saved the week:</p>

                <ul className="pointersSection">
                  <li className="themesPointer fd_colm">
                    <p>
                      <span className="highlightedText">ServiceNow soared 16%, Alphabet cloud metrics shone.</span>
                    </p>
                    <div className="relatedImg">
                      <img
                        src={image30}
                        alt=""
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image30)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </li>

                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Tesla rebounded, despite weak margins.</span>
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Durable Goods headline strong, core soft. </span>
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Zweig Breadth thrust trigger confirmed.</span>
                    </p>
                  </li>
                  <br></br>
                  <p className="highlightedText_header">Meanwhile, fund flows:</p>
                  <li className="themesPointer fd_colm">
                    <p>
                      <span className="highlightedText">Massive Treasury inflows</span>
                    </p>
                    <div className="relatedImg">
                      <img
                        src={image20}
                        alt=""
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image20)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </li>
                  <li className="themesPointer fd_colm">
                    <p>
                      <span className="highlightedText">Crypto mania reignited.</span>
                    </p>
                  </li>
                </ul>
              </div>

              <p>UK retail defied miserable consumer sentiment </p>
              <div className="relatedImg">
                <img
                  src={image21}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image21)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <p className="highlightedBoldText">Upcoming Week Ahead: Data Tsunami Incoming</p>
          <p className="highlightedText_header">Hold your breath: it's a mega-week ahead. </p>
          <div className="relatedImg">
            <img
              src={image28}
              alt=""
            />
            <div
              className="zoomBtn"
              onClick={() => handleLargeImg(image28)}
            >
              <button>
                <img
                  src={zoomImg}
                  alt=""
                />
              </button>
            </div>
          </div>
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap ">
              <div className="listImgWrapper">
                <ul className="pointersSection">
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Tuesday: </span>CB Consumer Confidence, JOLTS, GDPNow.
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Wednesday: </span>ADP Jobs, GDP, PCE inflation.
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Thursday: </span>ISM Manufacturing and BOJ interest rate decision (unch 0.5%e).
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Friday: </span>Non-Farm Payrolls.
                    </p>
                  </li>
                </ul>

                <ul className="pointersSection">
                  <p className="highlightedText_header">Earnings:</p>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Microsoft, Meta (Wednesday)</span>
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Amazon, Apple (Thursday)</span>
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Visa, UPS, Caterpillar midweek</span>
                    </p>
                  </li>
                </ul>
                <br></br>
                <p className="highlightedText_header">SPX volatility remains critical:</p>
                <div className="relatedImg">
                  <img
                    src={image23}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image23)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <p className="highlightedText_header">Also, almost everyone sees a pullback brewing—no surprise given the sentiment tilt:</p>
                <div className="relatedImg">
                  <img
                    src={image24}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image24)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap ">
              <div className="listImgWrapper">
                <p className="highlightedBoldText">Actionable Takeaway: “Half-Full Glass... But It's Still Leaking!”</p>
                <div className="listImgWrapper">
                  <p className="highlightedText_header">Alpha Capital’s read:</p>
                  <ul className="pointersSection">
                    <li className="themesPointer">
                      <p>SPX facing resistance around Fib levels — next 2–3 sessions critical.</p>
                    </li>
                    <li className="themesPointer">
                      <p>Zweig thrust and insider buying hint at medium-term upside.</p>
                    </li>
                    <li className="themesPointer">
                      <p>Near-term expect choppiness, headline-driven swings.</p>
                    </li>
                  </ul>

                  <p>Stay flexible. Stay sharp.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1G5yAzNPAx5soHx42_EWChxGR95KWJUZgt2DCFzERIM0/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog16;
